/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_UnlockedInputs */

const cs_workflow_unlocked = /** @type {(inputs: Workflow_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow odemčen`)
};

const en_workflow_unlocked = /** @type {(inputs: Workflow_UnlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow unlocked`)
};

/**
* | output |
* | --- |
* | "Workflow unlocked" |
*
* @param {Workflow_UnlockedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_unlocked = /** @type {((inputs?: Workflow_UnlockedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_UnlockedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_unlocked(inputs)
	return cs_workflow_unlocked(inputs)
});